module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Home/Key-a60762eaaa002480ec54fc589d4cb7a7.svg";